import { type Dispatch, useEffect, useState } from 'react';

import { type ClientData } from '../../.generated/types';
import { parseUrlDeviceData } from '../server/utils/urlDeviceData';

type PossibleCientData = ClientData | null;

interface UseClientDataResult {
	clientData: PossibleCientData;
	setClientData: Dispatch<PossibleCientData | ((clientData: PossibleCientData) => PossibleCientData)>;
}

const buildClientData = (): ClientData => {
	const baseClientData = {
		screen_height: String(window.innerHeight),
		screen_width: String(window.innerWidth),
	};

	const urlData = parseUrlDeviceData();

	return {...baseClientData, ...urlData.clientData};
};

export function useClientData(): UseClientDataResult {
	const [clientData, setClientData] = useState<PossibleCientData>(null);

	useEffect(() => {
		// If this code is run server-side (Next.js), window will be undefined
		// populate clientData during useEffect, which ony runs client-side
		if (!clientData) {
			setClientData(buildClientData());
		}
	}, [clientData]);

	return {
		clientData,
		setClientData,
	};
}
